import type { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit'

import {
  defineListener,
  isTransportError,
  resourceScopeTag,
  type ClientRuntimeExtra,
  type ModuleListener,
  type ModuleListenerApi,
} from '@krp/client-runtime'

import { aqsiDeliveryReconcile, deliveryApi } from '../api/deliveryApi'
import { deliveryReconcileRequested, deliveryReloadRequested } from './commands'
import { reconcileFailed, reconcileFinished, reconcileStarted } from './deliverySlice'

type ThunkApi = ThunkDispatch<unknown, ClientRuntimeExtra, UnknownAction>

/** Dispatch listener-а — настоящий dispatch стора с thunk-middleware; тип `ModuleListenerApi` его не обещает. */
const thunkOf = <S>(api: ModuleListenerApi<S>): ThunkApi => api.dispatch as ThunkApi

/** Listeners доставки: команда → собственные endpoints пакета. */
export function createDeliveryListeners<S>(): ModuleListener<S>[] {
  return [
    defineListener<S, ReturnType<typeof deliveryReloadRequested>>(deliveryReloadRequested.match, (action, api) => {
      api.dispatch(deliveryApi.util.invalidateTags([resourceScopeTag(action.payload.resourceId)]))
    }),
    defineListener<S, ReturnType<typeof deliveryReconcileRequested>>(
      deliveryReconcileRequested.match,
      async (action, api) => {
        const { resourceId } = action.payload
        api.dispatch(reconcileStarted({ resourceId }))
        const result = await thunkOf(api)(aqsiDeliveryReconcile.initiate({ resourceId }, { track: false }))
        if ('error' in result && isTransportError(result.error)) {
          // Отказ сервера (нет права, служба недоступна) — дословно, а не «что-то пошло не так».
          api.dispatch(
            reconcileFailed({
              resourceId,
              failure: {
                code: result.error.code,
                message: result.error.message,
                correlationId: result.error.correlationId,
              },
            }),
          )
          return
        }
        api.dispatch(reconcileFinished({ resourceId }))
      },
    ),
  ]
}
